import {
    ottopilotEventContainerValidator,
    type OttopilotEventContainer,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventContainersWorkspaceCapability/domain/OttopilotEventContainer";
import {
    ottopilotEventValidator,
    type OttopilotEvent,
} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEvent";
import type {ZodType} from "zod";

export type EventWithEventContainer = OttopilotEvent & {
    eventContainer: OttopilotEventContainer;
};

export const eventWithEventContainerValidator = ottopilotEventValidator.extend({
    eventContainer: ottopilotEventContainerValidator,
}) satisfies ZodType<EventWithEventContainer>;
